import React from "react";

import DoneIcon from "@mui/icons-material/Done";
import { Box, Checkbox, Table, TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import { useFormikContext } from "formik";
import { groupBy } from "lodash";
import { IProfileAssetClass } from "store/types/user/social";

import { IFormikValues } from "../EditWindow";

export const AssetClasses: React.FC = () => {
  const { values, setFieldValue } = useFormikContext<IFormikValues>();

  const tableCellCommonStyle = {
    padding: 0,
    color: "#bac7ce",
    fontSize: "13px"
  };

  const groupedData = Object.entries(groupBy(values.asset_classes, "group"));
  const tableBuilder = (data: [string, IProfileAssetClass[]], tableIndex: number) => {
    return (
      <Table key={tableIndex} sx={{ width: "100%", marginBottom: "35px" }} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell sx={{ ...tableCellCommonStyle, width: "10%" }} align="left"></TableCell>
            <TableCell sx={{ ...tableCellCommonStyle, width: "50%" }} align="left">
              {data[0]}
            </TableCell>
            <TableCell sx={{ ...tableCellCommonStyle, width: "20%" }} align="center"></TableCell>
            <TableCell sx={{ ...tableCellCommonStyle, width: "20%" }} align="center"></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data[1].map((item: IProfileAssetClass, index: number) => {
            return (
              <TableRow key={index}>
                <TableCell sx={{ ...tableCellCommonStyle }}>
                  {item.investment && item.learn_more && <DoneIcon sx={{ color: "#048365" }} />}
                </TableCell>

                <TableCell
                  sx={{
                    ...tableCellCommonStyle,
                    color: "#0a3142",
                    padding: "11px 0 11px 0 !important",
                    textAlign: "left !important"
                  }}
                  align="center"
                >
                  {item.title}
                </TableCell>
                <TableCell sx={{ ...tableCellCommonStyle }} align="center">
                  <Checkbox
                    onClick={() => {
                      const newAssetClasses = values.asset_classes.map((assetClass) => {
                        if (assetClass.id === item.id) {
                          return {
                            ...assetClass,
                            investment: !assetClass.investment
                          };
                        }
                        return assetClass;
                      });
                      setFieldValue("asset_classes", newAssetClasses);
                    }}
                    checked={item.investment}
                    sx={{
                      width: "20px",
                      height: "20px"
                    }}
                  />
                </TableCell>
                <TableCell sx={{ ...tableCellCommonStyle }} align="center">
                  <Checkbox
                    onClick={() => {
                      const newAssetClasses = values.asset_classes.map((assetClass) => {
                        if (assetClass.id === item.id) {
                          return {
                            ...assetClass,
                            learn_more: !assetClass.learn_more
                          };
                        }
                        return assetClass;
                      });
                      setFieldValue("asset_classes", newAssetClasses);
                    }}
                    checked={item.learn_more}
                    sx={{
                      width: "20px",
                      height: "20px"
                    }}
                  />
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    );
  };

  return (
    <div style={{ width: "100%", borderRadius: "8px", backgroundColor: "#fff" }}>
      <Box sx={{ padding: "32px" }}>
        <Table sx={{ width: "100%", marginBottom: "17px" }} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell sx={{ ...tableCellCommonStyle, width: "10%" }} align="left"></TableCell>
              <TableCell sx={{ ...tableCellCommonStyle, width: "50%" }} align="left">
                Type
              </TableCell>
              <TableCell sx={{ ...tableCellCommonStyle, width: "20%" }} align="center">
                Currently Investing
              </TableCell>
              <TableCell sx={{ ...tableCellCommonStyle, width: "20%" }} align="center">
                Would like to learn
              </TableCell>
            </TableRow>
          </TableHead>
        </Table>
        {groupedData.map((item: [string, IProfileAssetClass[]], index: number) => tableBuilder(item, index))}
      </Box>
    </div>
  );
};
